import { Building2 } from "lucide-react";
import { formatRelativeTime, getRenderer } from "./notificationRenderers";

// One inbox row: type label + relative time on top, the sentence beneath, and
// the customer (or ticket subject) last. Unread rows carry the blue tint and
// dot; read rows drop to 70% on white.
const NotificationRow = ({ item, onClick }) => {
  const meta = item.meta || {};
  const renderer = getRenderer(item);
  const titleParts = renderer.title(meta) || [];
  const detail = renderer.detail(meta);
  const isUnread = !item.readAt;

  return (
    <div
      onClick={() => onClick?.(item)}
      className={`w-full p-5 flex flex-col gap-1 border-b-[1px] border-[#EEF0F9] cursor-pointer ${
        isUnread ? "bg-[#F5F9FF] hover:bg-[#EAF3FF]" : "opacity-70 hover:bg-[#F8F9FE]"
      }`}
    >
      <div className="w-full flex items-start justify-between gap-3">
        <span
          className={`font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase ${
            isUnread ? "text-[#0065FD]" : "text-[#7C829A]"
          }`}
        >
          {renderer.label}
        </span>
        <div className="flex items-center gap-2">
          <span className="font-OpenSansRegular text-[12px] leading-[18px] tracking-[0.12px] text-[#7C829A]">
            {formatRelativeTime(item.createdAt)}
          </span>
          {isUnread && <span className="w-[8px] h-[8px] rounded-full bg-[#0065FD]" />}
        </div>
      </div>

      <div className="w-full pb-1 text-[14px] leading-[17.5px] text-[#1A2332]">
        {titleParts.map((part, index) => (
          <span key={index} className={part.bold ? "font-OpenSansSemiBold" : "font-OpenSansRegular"}>
            {part.text}
          </span>
        ))}
      </div>

      {detail && (
        <div className="w-full flex items-center gap-2 text-[#5F6477]">
          <Building2 size={14} className="shrink-0" />
          <span className="font-OpenSansRegular text-[12px] leading-[18px] tracking-[0.12px]">{detail}</span>
        </div>
      )}
    </div>
  );
};

export default NotificationRow;
